export const SET_VERIFICATION_IMAGE = (state, data) => {
  state.userVerificationImage = data;
};

